import { useState } from "react";
import { API_BASE } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { FileSpreadsheet } from "lucide-react";

const selCls = "h-9 border border-zinc-200 rounded-md px-2 text-sm bg-white";

export const FabricacionExport = () => {
  const [modo, setModo] = useState("hoy");
  const [campo, setCampo] = useState("fecha");
  const [fecha, setFecha] = useState("");
  const [desde, setDesde] = useState("");
  const [hasta, setHasta] = useState("");
  const [busy, setBusy] = useState(false);

  const exportar = async () => {
    if (modo === "fecha" && !fecha) return toast.error("Selecciona la fecha");
    if (modo === "rango" && (!desde || !hasta || desde > hasta)) return toast.error("Rango de fechas inválido");
    setBusy(true);
    try {
      const p = new URLSearchParams({ modo, campo });
      if (modo === "fecha") p.set("fecha", fecha);
      if (modo === "rango") { p.set("desde", desde); p.set("hasta", hasta); }
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_BASE}/reports/fabricacion.xlsx?${p.toString()}`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        credentials: "include",
      });
      if (!res.ok) throw new Error("No se pudo exportar");
      const blob = await res.blob();
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `fabricacion_${modo === "rango" ? `${desde}_${hasta}` : (fecha || "hoy")}.xlsx`;
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(a.href), 60000);
      toast.success("Excel generado");
    } catch (e) { toast.error(String(e.message || e)); }
    setBusy(false);
  };

  return (
    <div className="flex flex-wrap items-end gap-2 border border-zinc-200 rounded-md p-3 bg-white" data-testid="fab-export">
      <div>
        <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-semibold mb-1">Exportar Excel</div>
        <select value={modo} onChange={(e) => setModo(e.target.value)} className={selCls} data-testid="fab-export-modo">
          <option value="hoy">Hoy</option>
          <option value="fecha">Fecha específica</option>
          <option value="rango">Rango de fechas</option>
        </select>
      </div>
      <select value={campo} onChange={(e) => setCampo(e.target.value)} className={selCls} data-testid="fab-export-campo">
        <option value="fecha">Por fecha de creación</option>
        <option value="fecha_entrega">Por fecha de entrega</option>
      </select>
      {modo === "fecha" && <Input type="date" value={fecha} onChange={(e) => setFecha(e.target.value)} className="h-9 w-40" data-testid="fab-export-fecha" />}
      {modo === "rango" && (
        <>
          <Input type="date" value={desde} onChange={(e) => setDesde(e.target.value)} className="h-9 w-40" data-testid="fab-export-desde" />
          <Input type="date" value={hasta} onChange={(e) => setHasta(e.target.value)} className="h-9 w-40" data-testid="fab-export-hasta" />
        </>
      )}
      <Button onClick={exportar} disabled={busy} className="h-9 gap-1 bg-emerald-700 hover:bg-emerald-800" data-testid="fab-export-btn">
        <FileSpreadsheet className="w-4 h-4" /> {busy ? "Generando..." : "Exportar"}
      </Button>
    </div>
  );
};
